var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-inline-block", staticStyle: { "min-width": "32px" } },
      [_vm._v(_vm._s(_vm.row.conversation_count))]
    ),
    _vm._v(" "),
    _vm.canViewConversationIndex
      ? _c(
          "a",
          {
            staticClass: "btn btn-primary btn-sm",
            attrs: { href: _vm.row.conversationIndexUrl },
          },
          [_c("i", { staticClass: "fas fa-filter" })]
        )
      : _vm.canViewConversationList
      ? _c(
          "a",
          {
            staticClass: "btn btn-primary btn-sm",
            attrs: { href: _vm.row.conversationListUrl },
          },
          [_c("i", { staticClass: "fas fa-filter" })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }